initImageZoom({
  moduleSelector: '.cta-module',
  wrapSelector: '.cta-module__image',
  innerSelector: '.cta-module__image-inner',
  duration: '50%',
  triggerHook: 0.8,
});
